{
  "version": 1,
  "asset_id": "8fb85b2a-43f9-4441-9ba5-1b82098a6f3c",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/8fb85b2a-43f9-4441-9ba5-1b82098a6f3c/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1320w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/8fb85b2a-43f9-4441-9ba5-1b82098a6f3c/lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1320w.avif",
  "original_filename": "lecanto-fl-standing-seam-galvalume-metal-roof-destination-roofing-1320w.avif",
  "size": 34732,
  "content_type": "image/avif",
  "created_at": "2026-08-27T15:20:46Z"
}
